import httpService from '@/app/arch/services/HttpService';
import CrudRequest from 'Arch/components/crud/CrudRequest';

export default class LojaRequest extends CrudRequest {
  static baseUrl() {
    return '/cliente/loja';
  }

  static list(queryParams = {}, clienteId) {
    return httpService.get(`${this.baseUrl()}/by-cliente/${clienteId}`, {
      params: queryParams,
    });
  }

  static get(id) {
    return httpService.get(`${this.baseUrl()}/endDetalhes/${id}`);
  }

  static save(payload) {
    return httpService.post(`${this.baseUrl()}/add`, payload);
  }

  static getEndereco(cep) {
    return httpService.get(`/servicocep-api/logradouro/consulta?cep=${cep}`);
  }

  static listSegmento() {
    return httpService.get('/cliente/segmento/list-all');
  }

  static listByClient(clientId, params = {}) {
    return httpService.get(
      `${this.baseUrl()}/by-cliente/${clientId}`,
      {
        params,
      },
    );
  }

  static listAll(params = {}) {
    return httpService.get(
      `${this.baseUrl()}/list-all`,
      {
        params,
      },
    );
  }

  static listByDocument(document, params = {}) {
    return httpService.get(
      `${this.baseUrl()}/cpfcnpj/${document}`,
      {
        params,
      },
    );
  }
}
